/** Service Plan board row-open through the shell-scoped inspector. */
import { inject, Injector } from '@angular/core';
import { ActivityEntityName, ServicePlan } from '@jms/model';
import { EntityInspectors } from '@workbuddy/ui/v2/blocks/entity.inspector';

export async function navigateToServicePlanManage(item: ServicePlan): Promise<void> {

  if (!item?._id) return;
  const injector = inject(Injector);

  await injector.get(EntityInspectors).open({
    operation: 'edit',
    entity: ActivityEntityName.ServicePlan,
    id: item._id,
  });
}
